//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ServiceCard from "../service/ServiceCard.vue";
import PopUpSelectionContactLenses from "./PopUpSelectionContactLenses.vue";

export default {
    name: 'ServiceSelection',
    data: function () {
        return {
            search: '',
            currentService:null,
            isCustomModalMessageEnable: false,
            isOpenPopUpSelectionContactLenses: false
        }
    },
    props: ['services', 'active', 'hashSalon', 'hashSalonAddress', 'age'],
    components: {
        ServiceCard,
        PopUpSelectionContactLenses
    },
    computed: {
        list: function () {
            return this.services
                .filter((service) => {
                    // Если выбрано больше 18, то должны быть все возраста FALSE
                    if (this.age === "19") {
                        return Boolean(
                            !service.for_children_2_6 &&
                            !service.for_children_7_11 &&
                            !service.for_children_12_18 || service?.category_id === 5
                        )
                    }

                    let age = (this.age || "").replace("-", "_");
                    return Boolean(service[`for_children_${age}`])
                })
                .filter((service) => {
                    if (
                      service.id === 37 ||
                      service.id === 38 ||
                      service.id === 39 ||
                      service.id === 20
                    ) {
                        return null
                    }

                    if (!this.search) {
                        return service
                    }

                    if (service.name.toLowerCase().indexOf(this.search) === -1 && service.description.toLowerCase().indexOf(this.search) === -1) {
                        return null
                    }

                    return service
                })
        }
    },
    watch: {
        list: async function () {
            await this.mathHeightTitle();
        }
    },
    mounted: async function () {
        await this.mathHeightTitle();
    },
    methods: {
        onSelect: function (service, isConfirm) {
            //логика модалки для обучения
            if (service?.with_learning && !isConfirm) {
                this.isOpenPopUpSelectionContactLenses = true;
                this.currentService = service;
                return null
            }

            if(service?.category_id === 5) {
              this.isCustomModalMessageEnable = true;
              this.isOpenPopUpSelectionContactLenses = true;
              return null
            }

            this.isOpenPopUpSelectionContactLenses = false;
            this.isCustomModalMessageEnable = false;
            this.$emit('change', {name: 'service', value: service.id}, 1);
        },
        onChangeSearch: function (event) {
            this.search = event.target.value;
        },


        mathHeightTitle: async function () {
            if (this.$isServer) {
                return
            }

            const widthScreen = window.innerWidth;
            const gridSize = Boolean(widthScreen > 1499) ? 4 : Boolean(widthScreen > 999) ? 3 : 1;
            const listLength = this.list.length;
            const countLine = Math.ceil(listLength / gridSize);
            const allMatchTitles = document.querySelectorAll(".service-name");

            // Удаление стилей перед устоновкой максимальной высота
            await allMatchTitles.forEach(async (file) => {
                file.style = "";
            });

            // Удаление стилей максимальной высота
            for (let lineIndex = 0; lineIndex !== countLine; lineIndex++) {
                let maxHeightTitle = 0;
                for (let elementIndex = 0; elementIndex !== gridSize; elementIndex++) {
                    const elementKey = elementIndex + (lineIndex * gridSize);
                    if (maxHeightTitle < allMatchTitles[elementKey]?.clientHeight) {
                        maxHeightTitle = allMatchTitles[elementKey]?.clientHeight;
                    }
                }
                for (let elementIndex = 0; elementIndex !== gridSize; elementIndex++) {
                    const elementKey = elementIndex + (lineIndex * gridSize);
                    if (allMatchTitles[elementKey]) {
                        allMatchTitles[elementKey].style = `height: ${maxHeightTitle}px`;
                    }
                }
            }


            if (!document.getElementById('container-service')) {
              return
            }
            document.getElementById("container-service").style = "";
        },


      resetSalonHash: function () {
          this.$emit("resetSalonHash")
      },
      onResetCustomMessage: function () {
          this.isCustomModalMessageEnable = false;
      }
    }
};
